import { GzPolicyFullPageWindowFormWebComponent } from './component/GzPolicyFullPageWindowFormWebComponent';

export { GzPolicyFullPageWindowFormWebComponent };
